import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { CartItem } from '@pedix-workspace/utils';
import { AppCartItemsService } from '../../../app-cart-items.service';
import { isPlatformServer } from '@angular/common';

export const cartItemResolverFn: ResolveFn<CartItem> = (routeSnapshot: ActivatedRouteSnapshot) => {
  const platformId = inject(PLATFORM_ID);
  const cartItemsService = inject(AppCartItemsService);

  // CartItems are stored in sessionStorage; resolver will be executed again on the browser
  if (isPlatformServer(platformId)) {
    return null;
  }

  const { cartItemId } = routeSnapshot.params;

  return cartItemsService.findCartItem(cartItemId);
};
